import { render, staticRenderFns } from "./methodologies.vue?vue&type=template&id=6a476eea&scoped=true&"
import script from "./methodologies.vue?vue&type=script&lang=js&"
export * from "./methodologies.vue?vue&type=script&lang=js&"
import style0 from "./methodologies.vue?vue&type=style&index=0&id=6a476eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a476eea",
  null
  
)

export default component.exports